import { useContext, useEffect } from 'react';
import { LangContext } from '../../context/LangContext.js';

export function LangAriaBridge() {
  const lang = useContext(LangContext);
  const nep = !!(lang && lang.state && lang.state.np);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    const html = document.documentElement;
    const next = nep ? 'ne' : 'en';
    try { html.setAttribute('lang', next); } catch (e) {  }
  }, [nep]);

  return null;
}

export default LangAriaBridge;
